var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"see-all-seen-post-wrapper"},[_c('p',[_vm._v(" See all post of "),_c('span',[_vm._v("'"+_vm._s(_vm.searchText)+"'")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }